import { render, staticRenderFns } from "./SubFormulario.vue?vue&type=template&id=c6370ad4&scoped=true&"
import script from "./SubFormulario.vue?vue&type=script&lang=js&"
export * from "./SubFormulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6370ad4",
  null
  
)

export default component.exports